const fileSubmit = document.querySelector(
  '.user-import_students #admin-users > div.container.flex > div > form > button'
)

if (fileSubmit) {
  fileSubmit.addEventListener('click', () => {
    document.getElementsByClassName('uploading')[0].style.display = 'block'
  })
}
